The identifier for the `PositionOpening`.

Scheme restrictions:

- The `global` scheme creates the position opening asynchronously.
  This identifier will initially reference a missing object;
  the object should be created within a few minutes.
